var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M433,216.061c0-11.046-8.954-20-20-20H297c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h116 C424.046,236.061,433,227.107,433,216.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,276.061c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h76c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H297 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,236.061c11.046,0,20-8.954,20-20v-100c0-44.112-35.888-80-80-80H80c-44.112,0-80,35.888-80,80v200 c0,44.112,35.888,80,80,80h156v39.878h-70c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h180c11.046,0,20-8.954,20-20 c0-11.046-8.954-20-20-20h-70v-39.878h156c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40v-200c0-22.056,17.944-40,40-40h352c22.056,0,40,17.944,40,40v100 C472,227.107,480.954,236.061,492,236.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,196.061H99c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h116c11.046,0,20-8.954,20-20 C235,205.015,226.046,196.061,215,196.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,116.061H297c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h116c11.046,0,20-8.954,20-20 C433,125.015,424.046,116.061,413,116.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,116.061H99c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h116c11.046,0,20-8.954,20-20 C235,125.015,226.046,116.061,215,116.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,276.061H99c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h116c11.046,0,20-8.954,20-20 C235,285.015,226.046,276.061,215,276.061z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.7d8dd6b0e3767385fd5eb55663fe357b.svg";
export { ForwardRef as ReactComponent };